/**
 * The terms screen's one tick (Warren, 21 October 2026, evening: "one tick naming the three documents, each title a link
 * that opens it, then Accept. Keep recording acceptance of each document and version separately, as now.").
 *
 * The sentence names every document the screen lists, in the server's order: "I have read and agree to the Terms of
 * Service, the Payout Terms and the Sales Partner Program Terms." Returned as text and documents so the gate can make
 * each title a link.
 */
export function termsTickSentence<T extends { label: string }>(docs: readonly T[]): Array<string | T> {
  const out: Array<string | T> = ['I have read and agree to the '];
  docs.forEach((d, i) => {
    if (i > 0) out.push(i === docs.length - 1 ? ' and the ' : ', the ');
    out.push(d);
  });
  out.push('.');
  return out;
}

/** The plain text of the tick, for its accessible name and the tests. */
export const termsTickText = (docs: ReadonlyArray<{ label: string }>) =>
  termsTickSentence(docs).map(p => (typeof p === 'string' ? p : p.label)).join('');

/** What the one tick agrees to: every listed document at the version shown. A new list (a version published while the
 * screen is open) clears the tick, so it never carries over to a document the person has not seen named. */
export const termsTickKey = (docs: ReadonlyArray<{ doc_type: string; version: string }>) => docs.map(d => `${d.doc_type}:${d.version}`).join('|');

/** How a title opens its document: the rendered text in a dialog, else the hosted page in a new tab, else plain text. */
export function termsDocOpener(doc: { body: string | null; hosted_url: string | null }): 'dialog' | 'tab' | null {
  if (doc.body) return 'dialog';
  if (doc.hosted_url) return 'tab';
  return null;
}
